import { Card, Button } from "@/src/components";
import { useBalances } from "@/src/hooks/useBalances";
import { useStake } from "@/src/hooks/useStake";
import { useAccount } from "wagmi";
import { toast } from "react-hot-toast";
import { useAirdrop } from "@/src/hooks";
import { Timer } from "@/src/components/deadlineTimer";

export const PendingAirdrop = () => {
  const { airdropAmount, nextClaim, totalAmount, withdrawn } = useAirdrop();
  const { frbStakedBalance } = useBalances();
  const { onClaimAirdrop } = useStake();
  const { isConnected } = useAccount();

  const handleRewards = async () => {
    if (!isConnected) return;

    toast.promise(onClaimAirdrop(), {
      loading: "Transaction is in progress",
      success: "Successfully claimed airdrop",
      error: (data) => data,
    });
  }
  return (
    <Card className="flex flex-col h-full">
      <div className="mb-3">
        <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">Airdrop 1</h2>
      </div>
      {parseFloat(withdrawn) > parseFloat(frbStakedBalance) && (
        <div className="rounded-lg bg-warning/10 border border-warning/20 px-3 py-2 mb-3">
          <p className="text-xs text-warning">Stake additional {(parseFloat(withdrawn)-parseFloat(frbStakedBalance)).toFixed(2)} FRB to claim 100%</p>
        </div>
      )}
      <div className="space-y-0 divide-y divide-border/50 flex-1">
        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm text-muted-foreground">Next Amount</span>
          <span className="text-lg font-bold text-foreground font-mono">
            {parseFloat(airdropAmount).toFixed(2)} <span className="text-primary text-sm font-semibold">FRB</span>
          </span>
        </div>
        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm text-muted-foreground">Next Claim</span>
          <span className="text-lg font-bold text-primary font-mono tracking-wider">
            {parseInt(nextClaim) > 0 ? <Timer time={parseInt(nextClaim)}/> : "00:00:00:00"}
          </span>
        </div>
        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm text-muted-foreground">Total Pending</span>
          <span className="text-lg font-bold text-foreground font-mono">
            {parseFloat(totalAmount).toFixed(2)} <span className="text-primary text-sm font-semibold">FRB</span>
          </span>
        </div>
      </div>
      <div className="mt-4">
        <Button onClick={handleRewards} disabled={parseFloat(airdropAmount)===0 || parseFloat(nextClaim) > Date.now()/1000 }>
          Claim Airdrop
        </Button>
      </div>
    </Card>
  );
};
